<script>
import ModalPositionDetails from './ModalPositionDetails.vue'

export default {
  name: 'NewPositionCard',
  components: {
    ModalPositionDetails
  },
  props: {
    position: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      showModal: false,
      item: { ...this.position }
    }
  },
  methods: {
    toggleFavorite () {
      const isFavorite = this.item.isFavorite
      this.item.isFavorite = !isFavorite
      this.$store
        .dispatch(isFavorite ? 'attemptRemoveFavoritePosition' : 'attemptSaveFavoritePosition', this.position.id)
        .then(() => {
          this.item.isFavorite = !isFavorite
        }).catch((err) => {
          if (err.code === 403 && err.error === 'not_allowed') {
            this.showNotAllowedModal = true
          } else {
            this.directToRoute()
            this.$store.dispatch('attemptSetFeedbackMsg', {
              type: 'error',
              title: this.$t('content:error.load')
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleFavorite (isFavorite) {
      this.item.isFavorite = isFavorite
    },
    handleShare () {
      this.$store.dispatch('attemptSetFeedbackMsg', {
        type: 'success',
        title: this.$t('content:success.share')
      })
      navigator.clipboard.writeText(this.position.positionUrl)
    }
  },
  computed: {
    getshowModal () {
      return this.$store.getters.getshowModal
    }
  },
  created () {
    this.isFavoritePosition = this.isFavorite
  }
}
</script>
<template>
  <v-card class="position-card--container">
    <ModalPositionDetails v-if="showModal" @close="showModal = !showModal" :id="item.id" :placeholder="item"
      :onFavorite="handleFavorite" />
    <div class="position-card--upper" :style="{ backgroundColor: getPrimaryColor }">
      <div class="position-card--upper-actions">
        <v-icon class="cursor-pointer mr-2" color="#fff" @click="handleShare()">mdi-share-variant</v-icon>
        <v-icon class="cursor-pointer" color="#fff" @click="toggleFavorite()">{{ item.isFavorite ? 'mdi-heart'
          : 'mdi-heart-outline' }}</v-icon>
      </div>
      <div class="position-card--upper-title">
        <h3 class="title">{{ item.title }}</h3>
      </div>
      <div class="position-card--upper-owner">
        <v-avatar size="40px" class="mr-2">
          <v-img contain height="40px" width="40px" :src="item.company.logo" :alt="item.company.name"></v-img>
        </v-avatar>
        <p class="position-card--owner-name text-truncate">{{ item.company.name }}</p>
      </div>
    </div>
    <div class="position-card--lower">
      <div class="position-card--lower-data">
        <div class="position-card--content-type mb-3">
          <v-icon :color="getPrimaryColor">mdi-briefcase</v-icon>
          <p class="course-type" :style="{ color: getPrimaryColor }">{{ $t('application.card:position') }}</p>
        </div>
        <div class="position-card--card-data">
          <v-icon small :color="getPrimaryColor">mdi-map-marker</v-icon>
          <p class="data-text">{{ item.telecommute ? $t('discovery.details.label:details.remote') : item.location }}</p>
        </div>
        <div class="position-card--card-data">
          <v-icon small :color="getPrimaryColor">mdi-currency-usd</v-icon>
          <p class="data-text">{{ formatSalary(item) }}</p>
        </div>
      </div>
      <div class="position-card--footer_wrapper mt-4">
        <v-btn class="btn bold transform-unset" outlined :color="getPrimaryColor" @click.prevent="showModal = !showModal">
          {{ $t('global:show.more') }}
        </v-btn>
      </div>
    </div>
  </v-card>
</template>
<style lang="scss">
.position-card--container {
  margin: 8px;
  width: 296px;
  height: 380px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1) !important;

  .position-card--upper {
    padding: 16px;
    height: 220px;

    .position-card--upper-actions {
      text-align: right;
    }

    .position-card--upper-title {
      height: calc(24px * 4);
      overflow: hidden;
      margin: 16px 0;

      h3.title {
        font-family: $lato;
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        color: #FFFFFF;
        text-align: left;
        text-transform: capitalize;
      }
    }

    .position-card--upper-owner {
      display: flex;
      align-items: center;

      p.position-card--owner-name {
        margin: 0;
        font-family: 'Lato';
        font-style: normal;
        font-weight: 900;
        font-size: 16px;
        line-height: 28px;
        color: #FFFFFF;
      }
    }
  }

  .position-card--lower {
    padding: 16px;
    padding-top: 16px;
    padding-bottom: 0;
    text-align: right;

    .position-card--lower-data {
      margin-bottom: 8px;

      .position-card--content-type {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        p.course-type {
          margin-bottom: 0;
          margin-left: 8px;
          font-family: $lato;
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          color: #006C4C;
        }
      }

      .position-card--card-data {
        display: flex;
        align-items: center;
        margin-bottom: 4px;

        p.data-text {
          margin-bottom: 0;
          margin-left: 8px;
          font-family: 'Lato';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #454545;
        }
      }
    }

    .position-card--footer_wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .v-chip {
        background: linear-gradient(0deg, rgba(98, 181, 90, 0.1), rgba(98, 181, 90, 0.1)), #FFFFFF;
        ;
        height: 25px;

        p.data-text-chip {
          font-family: 'Lato';
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
